import React from "../_snowpack/pkg/react.js";
import styled from "../_snowpack/pkg/@emotion/styled.js";
import Editor from "./editor.js";
import {getPageEditor, getPageProduct} from "../common/utils.js";
import Image from "./image.js";
export default function ProductPreviewImage(props) {
  const {page, categoryPage, article} = props;
  const product = getPageProduct(page);
  const editor = getPageEditor(page);
  const backgroundColor = categoryPage?.content.color.color;
  if (!editor) {
    const image = product.cart_image;
    if (!image)
      return null;
    return /* @__PURE__ */ React.createElement(ImageView, {
      ...image
    });
  }
  return /* @__PURE__ */ React.createElement(EditorView, {
    ...props,
    article,
    backgroundColor,
    readOnly: true
  });
}
const ImageView = styled(Image)`
  width: 100%;
  height: auto;
  border-radius: 4px;
`;
const EditorView = styled(Editor)`
  width: 100%;
  height: auto;
  aspect-ratio: 1;
  border-radius: 4px;
  overflow: hidden;

  canvas,
  iframe {
    object-fit: cover;
  }
`;
